var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loader': true, 'inline': !_vm.blocking, 'blocking': _vm.blocking}},[_c('div',{staticClass:"loader-content"},[_c('div',{staticClass:"loader-spinner"}),_vm._v(" "),_c('div',{staticClass:"loader-message"},[_vm._t("default",[_vm._v(_vm._s(_vm.$t('generic.loading')))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d14a22c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = Es75
// module chunks = 1